import FrontendProviderFactory from '@v2/services/flowsteps/FrontendProviderFactory';
import { asClass, asFunction, asValue } from 'awilix';
import { AddressResolverFactory } from 'shared/execution/address-resolver-factory';
import { HubspotValueConverter } from 'shared/execution/workbook-api/converters/hubspot-value-converter';
import { HubspotCellFormatter } from 'shared/execution/workbook-api/formatters/hubspot-cell-formatter';
import { appEventBus } from 'shared/infrastructure/app-event-bus';
import { diContainer } from 'shared/infrastructure/di-container';
import { OfficeJsWorkbookApi } from '../workbook-api/office-js-workbook-api';

diContainer.register({
  providerFactory: asClass(FrontendProviderFactory).singleton(),
  valueConverter: asClass(HubspotValueConverter).transient(),
  workbookApiFactory: asFunction(() => (context: any) => new OfficeJsWorkbookApi(context.workbookContext)),
  eventBus: asValue(appEventBus),
  addressResolverFactory: asClass(AddressResolverFactory).singleton(),
  cellFormatter: asClass(HubspotCellFormatter).transient(),
});
